import { render, staticRenderFns } from "./MoComCulture.vue?vue&type=template&id=5214d93c&"
import script from "./MoComCulture.vue?vue&type=script&lang=js&"
export * from "./MoComCulture.vue?vue&type=script&lang=js&"
import style0 from "./MoComCulture.vue?vue&type=style&index=0&id=5214d93c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports